import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "en": {
        "translations": {
          "English": "English",
          "Spanish": "Español",
          "Español":"Español",
          "Required": "Required",
          "Expiration Date" : "Expiration Date",
          "Submitting" : "Submitting",
          "Submit" : "Submit",
          "Saving..." : "Saving...",
          "Close" : "Close",
          "Save" : "Save",
          "Clear" : "Clear Signature",
          "Signature" : "Signature:",
          "Employer *" : "Employer *",
          "Project Number *" : "Project Number *",
          "Role*" : "Role*",
          "Crafts*" : "Craft*",
          "Role" : "Role",
          "Craft" : "Craft",
          "Training Certificates" : "Training Certificates",
          "CertificationTextKey" : "Cards/certificates must be presented for each of the items necessary to perform the scope of work. Attach a copy of the card/certificate to this document to be kept on file in the Clayco field office. \n Please indicate below which certifications are being presented by the worker.",
          "Emergency Contact Info" : "Emergency Contact Info",
          "Contact Name*" : "Contact Name*",
          "Contact Phone*" : "Contact Phone*",
          "Voluntary Information" : "Voluntary Information",
          "Ethnicity" : "Ethnicity",
          "Gender" : "Gender",
          "Veteran" : "Veteran",
          "Zip Code" : "Zip Code",
          "Photo" : "Photo",
          "Worker Information" : "Worker Information",
          "RegistrationAcknowledgement": "By registering, you acknowledge and consent to our collection of information about you, including, without limitation: your name; contact information; work- or employment-related information (such as workplace safety records and certification or credentialing details); emergency contact information; and your photograph.",
          "First Name*" : "First Name*",
          "Last Name*" : "Last Name*",
          "Phone Number*" : "Phone Number*",
          "ClaycoLegal1" : "I, the undersigned, have participated in the Clayco Safety Orientation and understand the Clayco Safety & Health Code, including the so-stated policies:",
          "Clayco's Mandatory Safety Work Rules" : "Clayco's Mandatory Safety Work Rules",
          "Clayco's Substance Abuse Policy" : "Clayco's Substance Abuse Policy",
          "ClaycoLegal2" : "Clayco's Statement of Work Place Conduct",
          "ClaycoLegal3" : "I have been offered a personal copy of each of the above in the form of the Clayco Safety & Health Code, and I understand violation of any of these rules may lead to disciplinary action up to and including dismissal from the jobsite.",
          "ClaycoLegal4" : "I also understand that if I experience any injury on the job, I must report immediately to Clayco and my supervisor for care instructions.",
          "ClaycoLegal5" : "By signing this form, I acknowledge that the information contained herein may be updated and revised to reflect my current certifications, training, and information and that my signature shall be deemed valid for all such changes.",
          "RegisterSuccessKey" : "Thank you for registering! This page will automatically refresh",
          "Safe Work Rules Acknowledgement" : "Safe Work Rules Acknowledgement",
          "Work Rules Acknowledgement" : "Work Rules Acknowledgement",
          "SubmissionErrorKey":"Something went wrong during submission. Please check your form and try again.",
          "ValidatePhoneNumber": "Validate Phone Number",
          "NumberValidated": "Your phone number has been validated.  Feel free to close this page.",
          "NumberNotValidated": "Your phone number could not be validated.  Please contact an administrator for assistance.",
          "NumberValidationPending": "Your phone number is being validated...",
          "ValidationNotRun": "Phone number must be validated to support receiving text messages",
          "PhoneNumberNotValidated": "Please complete phone number validation by clicking the link sent to the provided number.",
          "LegalComm": "Nothing in this communication alters or modifies any Subcontractor contractual responsibility for all construction means, methods, techniques, sequences, procedures or coordination of all portions of their Subcontract Work at all times during the performance of the Subcontract Work in accordance with the applicable Subcontract and Contract Documents; nor is this communication a modification or waiver of any Subcontractor's contractually assumed responsibilities with respect to the same.",
          "VoluntaryNotice":"Sharing this information is completely voluntary and is not required to submit this form.  Information gathered will be used for contractual requirement reporting.",
          "CovidPolicy":"I have received, understand and will follow the protective measures against covid-19 established on this project. If I test positive for covid-19, I will report the case immediately and follow current isolation/quarantine measures.",
          "Receive Project/Safety notifications via Text": "Receive Project/Safety notifications via Text",
          "Thank you for registering!" : "Thank you for registering!",
          "Your profile has been created. You may close out of this window.": "Your profile has been created. You may close out of this window.",
          "Invalid phone number":"Invalid phone number",
          "Job Details":"Job Details",
          "Phone Number Verification": "Phone Number Verification",
          "EmployerLabel": "(Please indicate the company you work for/receive a paycheck from)",
          "Yes this is me": "Yes this is me",
          "No this is not me": "No this is not me",
          "Work History": "Work History",
          "Work History Statement": "One or more records were found that match your last name and phone number.  Please confirm your work history below.",
          "Confirm": "Confirm",
          "Confirmed": "Confirmed",
          "Reset": "Reset",
          "Certification": "Certification",
          "Certificates On File": "Certificates On File",
          "Verify Worker": "Verify Worker",
          "Cancel": "Cancel",
          "Cancel Edit": "Cancel Edit",
          "Verify Worker Instruction": "One or more records were found that match your last name and phone number.  To verify your information please click here to have a verification message sent to your phone.",
          "Verify Code Sent": "A verification code was sent to ",
          "Verify": "Verify",  
          "Please Enter Verification Code": "Please enter the verification code below and click Verify to continue.",
          "Enter Code": "Enter Code",
          "Enter Verification Code": "Please enter the verification code below.",
          "Request Verification Code": "Request Verification Code",
          "Invalid zipcode": "Invalid zipcode",
          "Thanks": "Thanks",
          "ForSubmitting": "for submitting your Safe Work Rules Acknowledgement Form.  Our records indicate you would like to receive Project/Safety notifications via Text.",
          "Edit Phone Number": "Edit Phone Number",
          "Send SMS Message": "Send SMS Message",
          "MessageSentText": "A message has been sent to this number",
          "This phone number cannot be verified": "The number you have entered cannot be used for notifications.  Please enter a number that can allow SMS messages to be sent.",
          "Continue": "Continue",
          "WRA": "WRA",
          "Jobsite ID": "Jobsite ID",
          "Jobsite ID Type": "Jobsite ID Type",
          "Add": "Add",
          "Remove": "Remove",
          "ResolveErrors": "Please resolve the errors above",
          "InvalidFileFormat": "File is not a valid certification format",
          "Name": "Name",
          "PhoneStartingCharacter": "Phone numbers cannot begin with 1 or 0. Please enter a valid phone number.",
        }
      },
      "es": {
        "translations": {
          "English": "English",
          "Spanish":"Español",
          "Español":"Español",
          "Required": "Requerido",
          'Expiration Date' : "Fecha De Caducidad",
          'Submitting' : "Sumisión",
          'Submit' : "Entregar",
          'Saving...' : "Ahorro...",
          'Close' : "Cerca",
          'Save' : "Ahorrar",
          'Clear' : "Borrar Firma",
          'Signature' : "Firma:",
          'Employer *' : "Empleador *",
          'Project Number *' : "Número De Proyecto*  (Después de escribir el número de proyecto, por favor seleccione el nombre del proyecto)",
          'Role*' : "Role*",
          'Crafts*' : "Artesanía/Oficio de Construción*",
          "Role" : "Role",
          "Craft" : "Artesanía/Oficio de Construción",
          'Training Certificates' : "Certificados De Entrenamiento",
          'CertificationTextKey' : "Se Deben Presentar Tarjetas/Certificados Para Cada Uno De Los Elementos Necesarios Para Realizar El Alcance Del Trabajo.  Adjunte Una Copia De La Tarjeta/Certificado A Este Documento Para Que Se Mantenga Archivado En La Oficina Local De Clayco.  \n Indique A Continuación Qué Certificaciones Está Presentando El Trabajador.",
          'Emergency Contact Info' : "Informacion De Contacto De Emergencia",
          'Contact Name*' : "Nombre De Contacto*",
          'Contact Phone*' : "Teléfono De Contacto*",
          'Voluntary Information' : "Información Voluntaria",
          'Ethnicity' : "Etnicidad",
          'Gender' : "Género",
          'Veteran' : "Veterano",
          'Zip Code' : "Código Postal",
          'Photo' : "Foto",
          'Worker Information' : "Información Del Trabajador",
          'RegistrationAcknowledgement': "Al registrarse, usted reconoce y da su consentimiento para que recopilemos información sobre usted, incluyendo, entre otros: su nombre; información de contacto; información relacionada con el trabajo o empleo (como registros de seguridad en el lugar de trabajo y detalles de certificación o credenciales); información de contacto de emergencia; y su fotografía.",
          'First Name*' : "Primer Nombre*",
          'Last Name*' : "Apellido*",
          'Phone Number*' : "Número De Teléfono*",
          "Receive Text Messages":"Recibir mensajes de texto",
          'ClaycoLegal1' : "Yo, El Abajo Firmante, He Participado En La Orientación De Seguridad De Clayco Y Entiendo Las Reglas De Trabajo De Seguridad De Clayco, Incluidas Las Pólizas Establecidas:",
          "Clayco's Mandatory Safety Work Rules" : "Normas Obligatorias De Seguridad En El Trabajo De Clayco",
          "Clayco's Substance Abuse Policy" : "Póliza De Clayco Sobre Abuso De Sustancias",
          "ClaycoLegal2" : "Declaración De Conducta En El Lugar De Trabajo De Clayco",
          "ClaycoLegal3" : "Me Han Ofrecido Una Copia Personal De Cada Uno De Los Anteriores En La Forma Del Libro De Reglas De Trabajo De Seguridad De Clayco, Y Entiendo Que La Violación De Cualquiera De Estas Reglas Puede Dar Lugar A Medidas Disciplinarias Que Pueden Incluir El Despido Del Lugar De Trabajo.",
          'ClaycoLegal4' : "También Entiendo Que Si Sufro Alguna Lesión En El Trabajo, Debo Informar De Inmediato A Clayco Y A Mi Supervisor Para Recibir Instrucciones De Cuidado.",
          "ClaycoLegal5" : "Al firmar este formulario, reconozco que la información contenida en este documento puede actualizarse y revisarse para reflejar mis certificaciones, capacitación e información actuales y que mi firma se considerará válida para todos esos cambios.",
          'RegisterSuccessKey' : "¡Gracias Por Registrarte!  Esta Página Se Actualizará Automáticamente",
          'Safe Work Rules Acknowledgement' : "Reconocimiento De Reglas De Trabajo Seguro",
          "Work Rules Acknowledgement" : "Reconocimiento De Reglas De Trabajo",
          "SubmissionErrorKey":"Algo salió mal durante el envío. Por favor revise su formulario y vuelva a intentarlo.",
          "ValidatePhoneNumber": "Validar número de teléfono",
          "NumberValidated": "Su número de teléfono ha sido validado. No dude en cerrar esta página.",
          "NumberNotValidated": "Su número de teléfono no pudo ser validado. Comuníquese con un administrador para obtener ayuda.",
          "NumberValidationPending": "Su número de teléfono está siendo validado...",
          "ValidationNotRun": "El número de teléfono debe estar validado para admitir la recepción de mensajes de texto.",
          "PhoneNumberNotValidated": "Complete la validación del número de teléfono haciendo clic en la longitud enviada al número proporcionado.",
          "LegalComm": "Nada en esta comunicación altera o modifica la responsabilidad contractual del Subcontratista por todos los medios, métodos, técnicas, secuencias, procedimientos o coordinación de todas las partes de su Trabajo Subcontratado en todo momento durante la ejecución del Trabajo Subcontratado de acuerdo con el Subcontrato y Contrato aplicable. Documentos; ni esta comunicación es una modificación o renuncia a las responsabilidades asumidas contractualmente por cualquier Subcontratista con respecto a la misma.",
          "VoluntaryNotice":"Compartir esta información es completamente voluntario y no es necesario enviar este formulario. La información recopilada se utilizará para informar los requisitos contractuales.",
          "CovidPolicy": "He recibido, entiendo y seguiré las medidas de protección contra covid-19 establecidas en este proyecto. Si doy positivo en la prueba de covid-19, informaré el caso inmediatamente y seguiré las medidas de aislamiento/cuarentena vigentes.",
          "Receive Project/Safety notifications via Text": "Reciba notificaciones de proyecto/seguridad por mensaje de texto",
          "Thank you for registering!" : "¡Gracias por registrarte!",
          "Your profile has been created. You may close out of this window.":"Tu perfil ha sido creado. Puede cerrar esta ventana.",
          "Invalid phone number":"Numero de telefono invalido",
          "Job Details":"Detalles del trabajo",
          "Phone Number Verification":"Verificación de número de teléfono",
          "This phone number cannot be verified": "Este número de teléfono no se puede verificar",
          "EmployerLabel": "(Por favor indique la empresa para la que trabaja/de la que recibe un cheque de pago)",
          "Invalid zipcode": "Código postal no válido",
          "Yes this is me": "Sí este soy yo",
          "No this is not me": "No este no soy yo",
          "Work History": "Historial de trabajo", 
          "Work History Statement": "Se encontraron uno o más registros que coinciden con su apellido y número de teléfono. Por favor confirme su historial laboral a continuación.",
          "Confirm": "Confirmar",
          "Confirmed": "Confirmado",
          "Reset": "Reajustar",
          "Certification": "Certificación",
          "Certificates On File": "Certificados En Archivo",
          "Verify Worker": "Verificar Trabajador",
          "Cancel": "Cancelar",
          "Cancel Edit": "Cancelar Editar",
          "Verify Worker Instruction": "Se encontraron uno o más registros que coinciden con su apellido y número de teléfono. Para verificar su información, haga clic aquí para recibir un mensaje de verificación en su teléfono.",
          "Verify Code Sent": "Se envió un código de verificación a",
          "Verify": "Verificar",  
          "Please Enter Verification Code": "Ingrese el código de verificación a continuación y haga clic en Verificar para continuar.",
          "Verification Code": "Código de verificación",
          "Enter Code": "Introduzca El Código",
          "Request Verification Code": "Solicitar Código De Verificación",
          "Thanks": "Gracias",
          "ForSubmitting": "por enviar su formulario de reconocimiento de reglas de trabajo seguro.  Nuestros registros indican que le gustaría recibir notificaciones de proyectos/seguridad por mensaje de texto. ",
          "Edit Phone Number": "Editar Número De Teléfono",
          "Send SMS Message": "Enviar Mensaje SMS",
          "MessageSentText": "Se ha enviado un mensaje a este número",
          "Continue": "Continuar",
          "WRA": "WRA",
          "Jobsite ID": "De Identificación Del Sitio De Trabajo",
          "Jobsite ID Type": "Tipo De Identificación Del Sitio De Trabajo",
          "Add": "Agregar",
          "Remove": "Eliminar",
          "ResolveErrors": "Por favor resuelva los errores anteriores",
          "InvalidFileFormat": "El archivo no es un formato de certificación válido",
          "Name": "Nombre",
          "Enter Verification Code": "Ingrese el código de verificación a continuación.",
          "PhoneStartingCharacter": "Los números de teléfono no pueden comenzar con 1 o 0. Ingrese un número de teléfono válido.",
        }
      }
    },
    preload: ['en', 'es'],
    lng: "en",
    fallbackLng: 'en',
    debug: true,
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
        escapeValue:false
    }
});

window.language = i18n.language;
i18n.on('languageChanged', (lng) => {
  window.language = lng;
});

export default i18n;
